import axios from "axios";

const API_BASE_URL = "https://api.havirkesht.ir";
const SELECTION_URL = `${API_BASE_URL}/farmer/selection`;

export interface FarmerSelectionItem {
  id: number;
  full_name?: string | null;
  father_name?: string | null;
  national_id?: string | null;
  crop_year_id?: number | null;
  commitment_numbers?: (string | number)[] | null;
}

export interface FarmerSelectionPage {
  items: FarmerSelectionItem[];
  total: number;
  size: number;
  pages: number;
}

export const getFarmerSelection = async (params: {
  cropYearId: number | string;
  farmerId?: number | string;
  search?: string;
  page?: number;
  size?: number;
}): Promise<FarmerSelectionPage> => {
  const query = new URLSearchParams();
  query.set("crop_year_id", String(params.cropYearId));
  if (params.farmerId != null) query.set("farmer_id", String(params.farmerId));
  if (params.search) query.set("search", params.search);
  if (params.page != null) query.set("page", String(params.page));
  if (params.size != null) query.set("size", String(params.size));

  const res = await axios.get(`${SELECTION_URL}?${query.toString()}`, {
    headers: { Authorization: `Bearer ${localStorage.getItem("app_atkey")}` },
  });

  const data = res?.data;
  return {
    items: Array.isArray(data?.items) ? data.items : [],
    total: data?.total ?? 0,
    size: data?.size ?? 0,
    pages: data?.pages ?? 0,
  };
};
